import React from 'react';

import { useAppSelector } from '@fd/customHooks/useAppSelector';
import { useUserPlatform } from '@fd/customHooks/useUserPlatform';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { getTranslate } from 'react-localize-redux';

const APP_DOWNLOAD_URL = 'https://api.flipdish.co/flipdish-app/download';

const MobileBannerContainerOuter = styled('div')(() => ({
  width: '100%',
  backgroundColor: '#095fb0',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

const MobileBannerContainerInner = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
}));

const MobileBannerTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  marginBottom: theme.spacing(1),
}));

const MobileBannerSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  lineHeight: theme.spacing(3),
}));

const MobileBannerActionButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  width: '100%',
  backgroundColor: theme.palette.common.white,
  textTransform: 'none',
  color: theme.palette.common.black,
}));

const MobileBannerActionIcon = styled(OpenInNewIcon)(({ theme }) => ({
  marginRight: theme.spacing(1),
  color: theme.palette.grey[500],
}));

const MobileAppBanner = () => {
  const translate = useAppSelector((state) => getTranslate(state.locale));
  const platform = useUserPlatform();
  return (
    <MobileBannerContainerOuter>
      <MobileBannerContainerInner>
        <MobileBannerTitle variant="h4">{translate('Download_and_log_in')}</MobileBannerTitle>
        <MobileBannerSubtitle variant="body1">
          {translate('Download_and_get_responsive_support')}
        </MobileBannerSubtitle>
        <MobileBannerActionButton
          onClick={() => window.open(APP_DOWNLOAD_URL, '_blank', 'noopener,noreferrer')}
        >
          <MobileBannerActionIcon />
          {platform === 'ios' ? translate('Go_to_app_store') : translate('Go_to_play_store')}
        </MobileBannerActionButton>
      </MobileBannerContainerInner>
    </MobileBannerContainerOuter>
  );
};

export default MobileAppBanner;
